import {Field, Input, Label, Message} from "@zendeskgarden/react-forms";
import {ReactElement} from "react";

import * as css from "./styles/acquisitionPropertyFormStyles.module.scss";

export interface IAcquisitionPropertyFormInput {
    label: string,
    placeholder: string,
    required?: boolean,
    value?: string | number,
    error?: string,
    onChange: (evt: React.ChangeEvent<HTMLInputElement>) => void,
    onBlur?: () => void,
    type?: string,
}

export default function AcquisitionPropertyFormInput(props: IAcquisitionPropertyFormInput): ReactElement {
    const {
        label,
        placeholder,
        required = false,
        value,
        error,
        onChange,
        onBlur,
        type = "text",
    } = props;

    return (
        <Field>
            <Label className={css.acquisitionPropertyFormLabel}>
                <span>{label}</span>
                {required && <span className={css.required}>REQUIRED</span>}
            </Label>
            <Input
                placeholder={placeholder}
                validation={error ? "error" : undefined}
                value={value}
                onChange={onChange}
                onBlur={onBlur}
                type={type}
            />
            {error && <Message validation="error">{error}</Message>}
        </Field>
    );
}